import React from "react";

import TitleSection from "../../components/TitleSection/TitleSection";
import HeroSection from "../../components/HeroSection/HeroSection";
import Subtitle from "../../components/Subtitle/Subtitle";
import Navbar from "../../components/Navbar/Navbar";
import DownloadApp from "./Sections/DownloadApp/DownloadApp";

import {
  titleObject,
  anonymousHeroObject,
  experienceHeroObject,
  credibilityHeroObject,
  downloadAppSubtitleObject,
  applicationSubtitleObject,
  featureSubtitleObject,
  chatFeatureObject,
  employeeFeatureObject,
} from "./Data";

function LandingPage() {
  return (
    <>
      <Navbar home />
      <div id="top">
        <TitleSection {...titleObject} />
      </div>
      <div id="product">
        {" "}
        <Subtitle {...applicationSubtitleObject} />
        <HeroSection {...chatFeatureObject} />
        <HeroSection {...employeeFeatureObject} />
      </div>
      <div id="feature">
        <Subtitle {...featureSubtitleObject} />
        <HeroSection {...anonymousHeroObject} />
        <HeroSection {...experienceHeroObject} />
        <HeroSection {...credibilityHeroObject} />
      </div>
      <div id="download">
        <Subtitle {...downloadAppSubtitleObject} />
        <DownloadApp />
      </div>
    </>
  );
}

export default LandingPage;
